import BaseEntity from 'src/entities/BaseEntity';
import EntityDescription, { Projection } from 'src/store/entities/types/EntityDescription';

/**
 * Creates a new instance of the given entity depending on the projection
 */
export function createEntity<ENTITY extends BaseEntity = BaseEntity>(
    json: any,
    entityDescription: EntityDescription,
    projection: Projection = Projection.NONE
): ENTITY {
    const entityConstructor = entityDescription.projectionsTypeMap[projection];

    if (entityConstructor == null)
        throw new Error(`No projection "${projection}" defined in EntityDescription "${entityDescription.name}"`);

    return new entityConstructor(json);
}

/**
 * Creates an array of the given entities depending on the projection
 */
export function createEntities<ENTITY extends BaseEntity = BaseEntity>(
    json: any[],
    entityDescription: EntityDescription,
    projection: Projection = Projection.NONE
): ENTITY[] {
    return json.map(j => createEntity<ENTITY>(j, entityDescription, projection));
}
